import { StreamMap } from '@m43/core';
import { MessagePayload } from '@m43/sockets-mark43';
import { NudgeType } from '../types';

export const getNudgePayload = <T>(
    message: MessagePayload<StreamMap, 'nudge'>,
    type: NudgeType
) => {
    return (message?.payload?.map?.[type] as unknown as T[]) ?? [];
};
